// extracted by mini-css-extract-plugin
export default {"pageTitleContainer":"singlePageTitle_pageTitleContainer__JJ6Gm","title":"singlePageTitle_title__0cvOI","pageTitleGoBack":"singlePageTitle_pageTitleGoBack__Epk6o"};